import { MarketSignal } from '@/modules/market-signals/model/market-signals/market-signal';
import { faClipboard } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './market-signals.module.css';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useState } from 'react';
import { copyText } from './market-signal-copy-resource';

export default function MarketSignalClipboardButton({ signal }: { signal: MarketSignal }) {
  const [show, setShow] = useState<boolean>(false);

  const renderTooltip = (props: {}) => (
    <Tooltip id="button-tooltip" {...props} show={show}>
      Copied to clipboard!
    </Tooltip>
  );

  const click = () => {
    setShow(true);
    navigator.clipboard.writeText(copyText(signal)).then(value => console.log(value));

    setTimeout(() => {
      setShow(false);
    }, 2000);
  };

  return (
    <OverlayTrigger
      show={show}
      placement="left"
      delay={{ show: 0, hide: 400 }}
      overlay={renderTooltip}
    >
      <span className={styles.clipboardButton} onClick={click}>
        <FontAwesomeIcon icon={faClipboard} />
      </span>
    </OverlayTrigger>
  );
}
